import BasicCode from "!!raw-loader!./checkboxtrees/Basic.tsx";
import ThreeLevelsCode from "!!raw-loader!./checkboxtrees/ThreeLevels.tsx";
import CustomCode from "!!raw-loader!./checkboxtrees/Custom.tsx";
import CardsCode from "!!raw-loader!./checkboxtrees/Cards.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Basic from "./checkboxtrees/Basic";
import ThreeLevels from "./checkboxtrees/ThreeLevels";
import Custom from "./checkboxtrees/Custom";
import Cards from "./checkboxtrees/Cards";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Basic", BasicCode, Basic),
		paneComponent("Three Levels", ThreeLevelsCode, ThreeLevels),
		paneComponent("Custom Spacing", CustomCode, Custom),
		paneComponent("Cards", CardsCode, Cards),
	];

	return (
		<Pane
			components={components}
			imports={"import {Checkbox} from \"designSystem/index\";"}
			muiApi="checkbox"
			muiComponent="checkboxes"
			{...props}
		/>
	);
};